import { render } from "./your-profile-your-details-component.vue?vue&type=template&id=437e7aca"
import script from "./your-profile-your-details-component.vue?vue&type=script&lang=js"
export * from "./your-profile-your-details-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__